import { defineStore } from 'pinia'
import apiService, { API_ROOT } from '@/services/apiService'


export const useAddonStore = defineStore('addonStore', {
    state: () => ({
        addons: [],
        loading: false,
        error: null,
    }),

    actions: {
        async fetchAddons() {
            this.loading = true
            this.error = null

            try {
                const response = await apiService.get('/addons')
                this.addons = response.data.map(addon => ({
                    ...addon,
                    image_url: addon.image ? `${API_ROOT}/storage/${addon.image}` : ''
                }))
            } catch (err) {
                this.error = err
                console.error('Błąd przy pobieraniu dodatków:', err)
            } finally {
                this.loading = false
            }
        },

        async deleteAddon(id) {
            this.loading = true
            this.error = null
            try {
                await apiService.post(`/addons-delete/${id}`)
                this.addons = this.addons.filter(a => a.id !== id)
            } catch (err) {
                this.error = err
                throw err
            } finally {
                this.loading = false
            }
        },

        async storeAddon(addonData) {
            this.loading = true
            this.error = null
            try {
                const response = await apiService.post('/addons', addonData)
                this.addons.push({
                    ...response.data,
                    image_url: response.data.image ? `${API_ROOT}/storage/${response.data.image}` : ''
                })
                return response.data
            } catch (err) {
                this.error = err
                throw err
            } finally {
                this.loading = false
            }
        },

        async updateAddon(id, addonData) {
            this.loading = true
            this.error = null
            try {
                const response = await apiService.post(`/addons/${id}`, addonData)
                const index = this.addons.findIndex(a => a.id === id)
                if (index !== -1) {
                    this.addons[index] = {
                        ...response.data,
                        image_url: response.data.image ? `${API_ROOT}/storage/${response.data.image}` : ''
                    }
                }
                return response.data
            } catch (err) {
                this.error = err
                throw err
            } finally {
                this.loading = false
            }
        },

        formatCode(code) {
            return code?.toUpperCase() || '-'
        }
    }
})
